import * as actionTypes from "../actions/actionTypes";

import {
  storeWallOfFameValues,
  setWallOfFameLoader,
  updateWallOfFame,
  createWallOfFame,
  deleteWallOfFame,
  pageIncreamentWallOfFame,
  clearAllWallOfFame,
} from "../utility/wallOfFameFunctions";

const initialState = {
  wallOfFame: [],
  total: "",
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_WALL_OF_FAME:
      return storeWallOfFameValues(state, action.wallOfFame, action.total);

    case actionTypes.UPDATE_WALL_OF_FAME:
      return updateWallOfFame(state, action.post);

    case actionTypes.SET_WALL_OF_FAME_LOADER:
      return setWallOfFameLoader(state, action.loaderValue);

    case actionTypes.CREATE_WALL_OF_FAME:
      return createWallOfFame(state, action.post);

    case actionTypes.DELETE_WALL_OF_FAME:
      return deleteWallOfFame(state, action.post);

    case actionTypes.PAGE_INCREAMENT_WALL_OF_FAME:
      return pageIncreamentWallOfFame(state);

    case actionTypes.CLEAR_ALL_WALL_OF_FAME:
      return clearAllWallOfFame(state);

    default:
      return state;
  }
};

export default reducer;
